// Stephen Boyd, @sspboyd
// August 2022.

// The following are a collection of mathematical constants I use in virtually
// all of my coding/art practice.
// The constants are typically used to modulate the relationships between
// visual elements on screen or bias the selection between different options.

const SQR_2 = 1.4142135623730951;
const TWO_PI = 6.283185307179586;

// Sourced from:
// https://en.wikipedia.org/wiki/List_of_mathematical_constants

const SR = {
  nat: 2.4142135623730951,
  inv: 1 / 2.4142135623730951,
  title: "The Silver Ratio",
  abbrv: "SR",
  forumla: 1 + Math.sqrt(2),
};

const PHI = {
  nat: 1.618033988749895,
  inv: 0.6180339887498948,
  title: "PHI",
  abbrv: "PHI",
  formula: (Math.sqrt(5) + 1) / 2,
};

const SGR = {
  nat: 1.46557123187676802665,
  inv: 1 / 1.46557123187676802665,
  abbrv: "SGR",
  title: "Super Golden Ratio",
};

const GA = {
  nat: 2.39996322972865332223,
  inv: 1 / 2.39996322972865332223,
  abbrv: "GA",
  title: "The Golden Angle",
};

const EUL = {
  nat: 2.71828182845904523536,
  inv: 1 / 2.71828182845904523536,
  abbrv: "EUL",
  title: "Euler's Number",
};

const RFC = {
  nat: 3.35988566624317755317,
  inv: 1 / 3.35988566624317755317,
  abbrv: "RFC",
  title: "Reciprocal Fibonacci constant",
};

const FC = {
  nat: 4.66920160910299067185,
  inv: 1 / 4.66920160910299067185,
  title: "Feigenbaum constant",
  abbrv: "FC",
};

export { TWO_PI, SQR_2, RFC, FC, SR, PHI, GA, SGR, EUL };
